import Raven from 'raven-js';
import * as UploadApi from 'documents-ui/api/UploadApi';
import uploadNewDocument from './uploadActions/uploadNewDocument';
import reuploadDocument from './uploadActions/reuploadDocument';
import uploadNewDocumentCHIRP from './uploadActions/uploadNewDocumentCHIRP';
import reuploadDocumentCHIRP from './uploadActions/reuploadDocumentCHIRP';
import { addAlert } from 'documents-lib/js/utils/addAlert';
import { MEGABYTE, UPLOAD_MEGABYTE_LIMIT } from 'documents-ui/constants/DocumentSizeTypes';
import { isUngatedToCHIRPEndpoints } from 'documents-ui/utils/gates';
import { getSelectedBrandId } from 'documents-ui/utils/getSelectedBrandId';
const startDocumentUpload = ({
  deckId,
  progressionRequest,
  fileName,
  folderId,
  onPercentProgress
}) => {
  if (!deckId) {
    return uploadNewDocument({
      progressionRequest,
      fileName,
      folderId
    });
  }
  return reuploadDocument({
    deckId,
    fileName,
    progressionRequest,
    onPercentProgress
  });
};
const logIfFileHasNoName = ({
  file,
  deckId,
  type,
  fileManagerFileId
}) => {
  if (file.name === undefined || file.name === null) {
    Raven.captureException(new Error(`File has no name during ${type} import`), {
      extra: {
        file,
        deckId,
        type,
        fileManagerFileId
      }
    });
  }
};
const isFileTooBig = ({
  file
}) => {
  const megabyteSize = file.size / MEGABYTE;
  return megabyteSize > UPLOAD_MEGABYTE_LIMIT;
};
export const uploadFile = ({
  file,
  deckId,
  folderId,
  onPercentProgress
}) => {
  if (isFileTooBig({
    file
  })) {
    return __dispatch => {
      addAlert('uploadFileSizeTooBig', 'danger', {
        sizeLimit: UPLOAD_MEGABYTE_LIMIT
      });
    };
  }
  const isChirpUngated = isUngatedToCHIRPEndpoints();
  if (isChirpUngated) {
    if (deckId) {
      return reuploadDocumentCHIRP({
        documentId: deckId,
        fileName: file.name,
        file,
        onPercentProgress
      });
    }
    return uploadNewDocumentCHIRP({
      file,
      fileName: file.name,
      folderId
    });
  }
  const brandId = getSelectedBrandId();
  const progressionRequest = onUploadProgress => UploadApi.uploadFile({
    file,
    deckId,
    folderId,
    brandId,
    onProgress: onUploadProgress
  });
  return startDocumentUpload({
    progressionRequest,
    onPercentProgress,
    deckId,
    fileName: file.name,
    folderId
  });
};
export const importFile = ({
  file,
  type,
  deckId,
  folderId,
  fileManagerFileId,
  onPercentProgress
}) => {
  logIfFileHasNoName({
    file,
    deckId,
    fileManagerFileId,
    type
  });
  const brandId = getSelectedBrandId();
  const progressionRequest = () => UploadApi.importFile({
    type,
    file,
    deckId,
    folderId,
    brandId,
    fileManagerFileId
  });
  return startDocumentUpload({
    progressionRequest,
    onPercentProgress,
    deckId,
    fileName: file.name,
    folderId
  });
};